export default defineAppConfig({
    title: '华美云',
    theme: {
      dark: true,
      colors: {
        primary: '#ff0000'
      }
    }
  })
  